<template>
  <t-form labelWidth="80px">
    <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm" />
    <CptInputOptionBase :attribute="attribute" :currentCpt="currentCpt" @changeSize="changeSize"/>
  </t-form>
</template>

<script>
import CptData from "@/components/element/options/comp/cpt-data";
import CptInputOptionBase from "@/components/element/options/comp/cpt-input-option-base";
export default {
  name: "cpt-textarea-option",
  props: {
      attribute:Object,
      cptDataForm: Object,
      currentCpt: Object,
    },
  components: {CptInputOptionBase,CptData },
  data(){
    return {
      sizeOptions: {
        small: { width: this.currentCpt.cptWidth, height: 56 },
        medium: { width: this.currentCpt.cptWidth, height: 66 },
        large: { width: this.currentCpt.cptWidth, height: 76 },
      },
    }
  },
  mounted() {
  },
  methods: {
    changeSize(val) {
      const sizeAttributes = this.sizeOptions[val];
      if (sizeAttributes) {
        this.attribute.width = sizeAttributes.width;
        this.attribute.height = sizeAttributes.height;
      } else {
        console.warn(`Invalid size option: ${val}`);
      }
    },
  },
}
</script>

<style scoped>

</style>